/**
 * Ленивая кнопка сканера QR (тот же паттерн, что PacksLazy/packs-lazy.tsx):
 * камера, детектор и qr-scanner фолбэк нужны не каждому посетителю — в
 * стартовый бандл не идут.
 */
import type { ComponentType } from 'preact'
import { useEffect, useState } from 'preact/hooks'

interface DockProps {
  readonly onVenue: (path: string) => void
}

let cached: ComponentType<DockProps> | null = null

export function QrScanLazy({ onVenue }: DockProps) {
  // Ленивый инициализатор обязателен (см. IsoLazy): иначе Preact вызвал бы
  // компонент как функцию-инициализатор состояния.
  const [View, setView] = useState<ComponentType<DockProps> | null>(() => cached)

  useEffect(() => {
    if (View) return
    let alive = true
    void import('./qr-scan-dock')
      .then((m) => {
        cached = m.QrScanDock
        if (alive) setView(() => m.QrScanDock)
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [View])

  if (!View) return null
  return <View onVenue={onVenue} />
}
